module.exports = __webpack_public_path__ + "img/bsg (7).b38e668a.jpg";